/**
 * https://stackoverflow.com/a/41061471/16807852
 */
export const clearUrlParamsWithoutRefreshPage = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

export default clearUrlParamsWithoutRefreshPage;
